var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgShareR(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 585,
    viewBox: "0 0 327 585",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.964 491C127.964 491 110.184 614.406 181.612 576.34C253.039 538.275 276.951 515.558 326 549.94",
    stroke: "#FD612E",
    strokeWidth: 1.28,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0061 -32C23.0061 -32 20.9385 55.4775 92.7884 15.6209C164.638 -24.2357 209.092 -49.599 186.865 8.89185C164.638 67.3827 134.658 92.746 196.686 75.147C258.715 57.548 192.034 115.521 188.933 117.592",
    stroke: "#FD612E",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95566 339.548C8.95566 339.548 -7.43658 369.23 5.92034 379.555C19.2773 389.881 5.13284 420.336 3.47629 420.518",
    stroke: "#FD612E",
    strokeWidth: 1.36,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5 548.098C262.851 548.098 268 542.927 268 536.549C268 530.171 262.851 525 256.5 525C250.149 525 245 530.171 245 536.549C245 542.927 250.149 548.098 256.5 548.098Z",
    fill: "#11405D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186 548H86V567.813H186V548Z",
    fill: "#FCC75F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118 158.621L251.055 116L306.44 253.572L144.218 301.459L118 158.621Z",
    fill: "#FCC75F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.697 223.81L179.064 218.133C188.524 208.68 192.153 195.683 188.771 183.388C184.041 166.205 166.643 152.668 141.032 146.263C128.32 143.082 120.778 136.885 118.616 127.846C115.863 116.325 122.349 100.965 137.891 82.172C145.075 73.557 152.873 65.4783 161.225 58L166.463 64.0497C158.421 71.2752 150.903 79.0688 143.968 87.3709C137.756 94.8916 133.067 101.845 130.028 108.048C126.499 115.277 125.258 121.312 126.378 125.985C127.811 131.969 133.235 136.061 142.965 138.498C157.854 142.225 170.134 148.08 179.464 155.905C187.994 163.048 193.877 171.818 196.463 181.262C200.622 196.365 196.224 212.272 184.697 223.81ZM166.463 64.0497L163.843 61.0248L166.463 64.0497Z",
    fill: "#FD612E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73 210.706L131.943 170L173 210.706L129.504 257.112L102.268 234.316L125.846 211.521L73 210.706Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.92 338.782L256.867 415.107L109.204 418.315L126.92 338.782Z",
    fill: "#79B473"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M279 289.028C284.523 289.028 289 284.544 289 279.014C289 273.483 284.523 269 279 269C273.477 269 269 273.483 269 279.014C269 284.544 273.477 289.028 279 289.028Z",
    fill: "#11405D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShareR);
export default __webpack_public_path__ + "static/media/bg-share-r.3e7b6bb478785287ee982f39652294fb.svg";
export { ForwardRef as ReactComponent };